module.exports = __webpack_public_path__ + "images/leftArrow-b083ae23ebcf892c44e56d4d42a1cca0.svg";